/* Sparset Builder
 * Feste Bundles aus 2+ SKUs. Pro Slot wählt der Kunde Produkt (falls Collection-
 * Slot) + Variante. Add-to-Cart legt die echten Komponenten-SKUs mit Bundle-
 * Properties in den Warenkorb; der Rabatt kommt aus der Shopify Discount Function.
 */
(function () {
  'use strict';

  var moneyFormat = (window.Shopify && window.Shopify.money_format) || '€{{amount_with_comma_separator}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function pickProductImage(product) {
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image.src) return product.featured_image.src;
    }
    if (Array.isArray(product.images) && product.images.length) {
      var f = product.images[0];
      return typeof f === 'string' ? f : (f && f.src) || '';
    }
    return '';
  }

  function imgUrl(src, w) {
    if (!src) return '';
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    return src + sep + 'width=' + w;
  }

  function pickVariantImage(variant, fallback) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }
    return fallback || '';
  }

  // Zähler innerhalb einer Seite/Session; für die Eindeutigkeit der Bundle-ID
  // sorgen zusätzlich Zeitstempel und Zufallsteil (siehe addToCart).
  var bundleCounter = 0;

  function Sparset(root) {
    this.root = root;
    try {
      this.cfg = JSON.parse(root.getAttribute('data-config') || '{}');
    } catch (e) {
      this.cfg = {};
    }
    this.slots = Array.isArray(this.cfg.slots) ? this.cfg.slots : [];
    this.pricing = this.cfg.pricing || {};
    this.bundleLabel = this.cfg.bundleLabel || 'Sparset';
    this.hideProperty = !!this.cfg.hideProperty;

    // Theme-Farbtabelle (settings.color_swatches): Keys normalisiert, damit
    // Lookups unabhängig von Groß-/Kleinschreibung treffen.
    this.swatchMap = {};
    var rawMap = this.cfg.swatches || {};
    for (var smKey in rawMap) {
      if (Object.prototype.hasOwnProperty.call(rawMap, smKey)) {
        this.swatchMap[String(smKey).toLowerCase().trim()] = rawMap[smKey];
      }
    }

    // Auswahl pro Slot-Index: { product, variant, image }
    this.selection = new Array(this.slots.length).fill(null);
    // Pro Collection-Slot: gewähltes Produkt-Handle
    this.chosenProduct = new Array(this.slots.length).fill(null);
    // Cache: handle -> product (aus /products/<handle>.js)
    this.productCache = {};
    // Farb-Vorauswahl: Picker pro Slot, ob der Kunde die Farbe selbst gewählt
    // hat (dann nie mehr überschreiben) und die zuletzt vom Kunden gewählte Farbe.
    this.pickers = new Array(this.slots.length).fill(null);
    this.userPickedColor = new Array(this.slots.length).fill(false);
    this.lastColor = null;
    // Die Farb-Vorauswahl der anderen Slots passiert nur beim ALLERERSTEN
    // Farb-Klick im Set; danach ändert jeder Klick nur noch den eigenen Slot.
    this.prefillDone = false;
    // Nach CTA-Klick mit unvollständiger Auswahl: konkrete Hinweise anzeigen.
    this.showMissing = false;
    // Set-Geschenk (z. B. 100 Leuchtsterne): kommt gratis mit ins Set,
    // Rabatt auf 0 € macht die Discount-Function (_bundle_gift-Property).
    this.giftCfg = (this.cfg.gift && this.cfg.gift.product) ? this.cfg.gift : null;
    this.gift = null;

    this.elSlots = root.querySelector('[data-sparset-slots]');
    this.elList = root.querySelector('[data-sparset-list]');
    this.elSubtotal = root.querySelector('[data-sparset-subtotal]');
    this.elSavingRow = root.querySelector('[data-sparset-saving-row]');
    this.elSaving = root.querySelector('[data-sparset-saving]');
    this.elGiftRow = root.querySelector('[data-sparset-gift-row]');
    this.elGiftLabel = root.querySelector('[data-sparset-gift-label]');
    this.elGiftSaving = root.querySelector('[data-sparset-gift-saving]');
    this.elTotal = root.querySelector('[data-sparset-total]');
    this.elTotalSavingRow = root.querySelector('[data-sparset-total-saving-row]');
    this.elTotalSaving = root.querySelector('[data-sparset-total-saving]');
    this.elHint = root.querySelector('[data-sparset-hint]');
    this.elCta = root.querySelector('[data-sparset-cta]');
    this.elError = root.querySelector('[data-sparset-error]');

    if (this.elCta) this.elCta.addEventListener('click', this.addToCart.bind(this));
    this.initSlots();
    if (this.giftCfg) this.loadGift();
    this.initGalleryColorBadge();
    this.renderSummary();
  }

  /* ---------- PDP-Galerie: Farb-Sync + Farbnamen-Badge ---------- */

  // Ist dieser Alt-Text ein (bekannter) Farbname unserer Set-Bilder?
  Sparset.prototype.isColorAlt = function (alt) {
    var a = String(alt || '').toLowerCase().trim();
    if (!a || a.length > 40) return false;
    if (this.swatchMap[a] || COLOR_FALLBACK[a]) return true;
    var colors = this.cfg.colors || [];
    for (var i = 0; i < colors.length; i++) {
      if (String(colors[i]).toLowerCase().trim() === a) return true;
    }
    return false;
  };

  // Beim ERSTEN Farb-Klick: Galerie zum passenden Set-Bild scrollen.
  Sparset.prototype.showGalleryImageForColor = function (colorVal) {
    var exact = String(colorVal || '').toLowerCase().trim();
    var mainTone = exact.split(/\s*[&\/+]\s*|\s+und\s+/)[0].trim(); // Kombi -> Hauptton
    document.querySelectorAll('media-carousel').forEach(function (car) {
      var slides = car.querySelectorAll('[data-media-id]');
      var hit = null;
      slides.forEach(function (slide) {
        if (hit) return;
        var img = slide.querySelector('img');
        var alt = img ? String(img.alt || '').toLowerCase().trim() : '';
        if (alt === exact || alt === mainTone) hit = slide;
      });
      if (hit) car.scrollTo({ left: hit.offsetLeft, behavior: 'smooth' });
    });
  };

  // Dezentes Badge unten links im Galerie-Bild: zeigt den Farbnamen des
  // gerade sichtbaren Set-Bildes (liest den Alt-Text der Slides).
  Sparset.prototype.initGalleryColorBadge = function () {
    var self = this;
    document.querySelectorAll('media-carousel').forEach(function (car) {
      if (car.__sparsetBadge) return;
      var slides = car.querySelectorAll('[data-media-id]');
      if (!slides.length) return;
      var host = car.parentElement;
      if (!host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var badge = document.createElement('div');
      badge.className = 'sparset-media-color';
      host.appendChild(badge);
      car.__sparsetBadge = badge;

      var t = null;
      function update() {
        // Slide, dessen linke Kante der aktuellen Scroll-Position am nächsten liegt
        var best = null, bestDist = Infinity;
        car.querySelectorAll('[data-media-id]').forEach(function (slide) {
          var d = Math.abs(slide.offsetLeft - car.scrollLeft);
          if (d < bestDist) { bestDist = d; best = slide; }
        });
        var alt = best && best.querySelector('img') ? best.querySelector('img').alt : '';
        if (alt && self.isColorAlt(alt)) {
          badge.textContent = alt;
          badge.classList.add('is-visible');
        } else {
          badge.classList.remove('is-visible');
        }
      }
      car.addEventListener('scroll', function () {
        if (t) clearTimeout(t);
        t = setTimeout(update, 90);
      }, { passive: true });
      update();
    });
  };

  // Geschenk-Variante auflösen (per variantTitle, sonst erste verfügbare).
  // Ist das Geschenk ausverkauft, wird es still weggelassen.
  Sparset.prototype.loadGift = function () {
    var self = this;
    this.fetchProduct(this.giftCfg.product).then(function (product) {
      if (!product) return;
      var variants = product.variants || [];
      var want = colorNorm(self.giftCfg.variantTitle || '');
      var v = null;
      if (want) {
        v = variants.find(function (x) { return colorNorm(x.title) === want; }) || null;
      }
      if (!v) v = variants.find(function (x) { return x.available; }) || null;
      if (!v || !v.available) return;
      self.gift = {
        variantId: v.id,
        price: typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100),
        label: self.giftCfg.label || product.title,
        image: pickVariantImage(v, pickProductImage(product)),
        qty: parseInt(self.giftCfg.qty, 10) || 1,
      };
      self.renderSummary();
    });
  };

  // Vorbestell-Varianten (Marc 30.07.2026): Serverseitig ermittelte IDs
  // (Liquid: policy=continue + Bestand<=0) werden hier als NICHT verfuegbar
  // markiert - Sparsets versprechen "sofort versandbereit", Vorbestellung
  // laeuft nur ueber die Produktseite.
  Sparset.prototype.stripPreorder = function (product) {
    var ids = this.cfg.preorderVariantIds;
    if (!ids || !ids.length || !product || !product.variants) return product;
    product.variants.forEach(function (v) {
      if (ids.indexOf(v.id) !== -1) v.available = false;
    });
    return product;
  };

  Sparset.prototype.fetchProduct = function (handle) {
    var self = this;
    if (this.productCache[handle]) return Promise.resolve(this.productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) { self.stripPreorder(p); self.productCache[handle] = p; } return p; })
      .catch(function () { return null; });
  };

  Sparset.prototype.fetchCollection = function (handle) {
    var self = this;
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var products = (d && d.products) || [];
        products.forEach(function (p) { self.stripPreorder(p); });
        return products;
      })
      .catch(function () { return []; });
  };

  Sparset.prototype.initSlots = function () {
    var self = this;
    if (!this.elSlots) return;
    var slotEls = this.elSlots.querySelectorAll('[data-sparset-slot]');
    slotEls.forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-sparset-slot'), 10);
      var productHandle = el.getAttribute('data-slot-product') || '';
      var collectionHandle = el.getAttribute('data-slot-collection') || '';
      var body = el.querySelector('[data-slot-body]');

      if (productHandle) {
        // Fester Produkt-Slot → direkt Variantenauswahl
        self.chosenProduct[idx] = productHandle;
        self.fetchProduct(productHandle).then(function (product) {
          self.renderProductPicker(idx, body, product);
        });
      } else if (collectionHandle) {
        // Collection-Slot → erst Produktauswahl, dann Varianten
        self.fetchCollection(collectionHandle).then(function (products) {
          self.renderCollectionPicker(idx, body, products);
        });
      } else if (body) {
        body.innerHTML = '<p class="sparset-slot__err">Slot nicht konfiguriert.</p>';
      }
    });
  };

  /* ---------- Collection-Slot: Produktauswahl ---------- */

  Sparset.prototype.renderCollectionPicker = function (idx, body, products) {
    var self = this;
    if (!body) return;
    if (!products.length) {
      body.innerHTML = '<p class="sparset-slot__err">Keine Produkte gefunden.</p>';
      return;
    }
    var opts = products.map(function (p) {
      return '<option value="' + esc(p.handle) + '">' + esc(p.title) + '</option>';
    }).join('');
    body.innerHTML =
      '<label class="sparset-slot__field">' +
        '<span class="sparset-slot__field-label">Produkt wählen</span>' +
        '<select class="sparset-slot__select" data-slot-product-select>' +
          '<option value="">– bitte wählen –</option>' + opts +
        '</select>' +
      '</label>' +
      '<div data-slot-variant-wrap></div>';

    var select = body.querySelector('[data-slot-product-select]');
    select.addEventListener('change', function () {
      var handle = select.value;
      self.chosenProduct[idx] = handle || null;
      self.selection[idx] = null;
      self.pickers[idx] = null;
      self.userPickedColor[idx] = false;
      var wrap = body.querySelector('[data-slot-variant-wrap]');
      wrap.innerHTML = '';
      self.renderSummary();
      if (!handle) return;
      self.fetchProduct(handle).then(function (product) {
        self.renderVariantPicker(idx, wrap, product);
      });
    });
  };

  /* ---------- Produkt-Slot / Varianten ---------- */

  Sparset.prototype.renderProductPicker = function (idx, body, product) {
    if (!body) return;
    if (!product) {
      body.innerHTML = '<p class="sparset-slot__err">Produkt nicht gefunden.</p>';
      return;
    }
    body.innerHTML =
      '<div class="sparset-slot__product">' +
        '<img class="sparset-slot__img" data-slot-thumb src="' + esc(imgUrl(pickProductImage(product), 160)) + '" alt="" width="60" height="60" loading="lazy">' +
        '<span class="sparset-slot__ptitle">' + esc(product.title) + '</span>' +
      '</div>' +
      '<div data-slot-variant-wrap></div>';
    var wrap = body.querySelector('[data-slot-variant-wrap]');
    this.renderVariantPicker(idx, wrap, product);
  };

  Sparset.prototype.renderVariantPicker = function (idx, wrap, product) {
    var self = this;
    if (!wrap || !product) return;
    var variants = product.variants || [];
    var optionNamesAll = (product.options || []).map(function (o) { return o.name || o; });

    // Vorgaben aus der Set-Config: erlaubte Farben (Set-weit) + erlaubte
    // Options-Werte pro Slot (z. B. nur Baby-Größen). Nicht erlaubte Werte
    // werden komplett ausgeblendet – nicht nur deaktiviert.
    var slotCfg = this.slots[idx] || {};
    var allowedColors = Array.isArray(this.cfg.colors) && this.cfg.colors.length ? this.cfg.colors : null;
    var optFilters = (slotCfg.options && typeof slotCfg.options === 'object') ? slotCfg.options : null;
    var prefer = (slotCfg.prefer && typeof slotCfg.prefer === 'object') ? slotCfg.prefer : null;

    function allowedValue(pos, val) {
      var name = optionNamesAll[pos];
      if (optFilters && Array.isArray(optFilters[name])) {
        return optFilters[name].some(function (x) { return colorNorm(x) === colorNorm(val); });
      }
      if (allowedColors && isColorOption(name)) {
        var vt = colorTokens(val);
        return allowedColors.some(function (c) {
          if (colorNorm(c) === colorNorm(val)) return true;
          var ct = colorTokens(c);
          return vt.some(function (t) { return ct.indexOf(t) !== -1; });
        });
      }
      return true;
    }

    function allowedVariant(v) {
      return optionNamesAll.every(function (_, pos) { return allowedValue(pos, v['option' + (pos + 1)]); });
    }

    variants = variants.filter(allowedVariant);

    // Komplett ausverkaufte Farben ganz entfernen (nicht nur durchstreichen):
    // Eine Farbe, für die es in KEINER Variation (Größe/Typ/…) noch eine
    // verfügbare Variante gibt, wird gar nicht erst angeboten.
    var colorPosAll = -1;
    optionNamesAll.forEach(function (n, p) { if (colorPosAll === -1 && isColorOption(n)) colorPosAll = p; });
    if (colorPosAll !== -1) {
      var colorHasStock = {};
      variants.forEach(function (v) {
        if (v.available) colorHasStock[v['option' + (colorPosAll + 1)]] = true;
      });
      variants = variants.filter(function (v) { return colorHasStock[v['option' + (colorPosAll + 1)]]; });
    }

    if (!variants.length) {
      wrap.innerHTML = '<p class="sparset-slot__err">Keine passende Variante verfügbar.</p>';
      return;
    }

    // Single-Variante (Option "Title") → automatisch wählen, kein Picker
    var onlyTitle = (product.options || []).length === 1 &&
      /^(title|titel)$/i.test((product.options[0] && (product.options[0].name || product.options[0])) || '');
    if (variants.length === 1 || onlyTitle) {
      this.commitVariant(idx, product, variants[0]);
      wrap.innerHTML = variants[0] && variants[0].available
        ? '<p class="sparset-slot__ok">Ausgewählt</p>'
        : '<p class="sparset-slot__err">Ausverkauft</p>';
      this.renderSummary();
      return;
    }

    // Option-Gruppen rendern (Farbe → Swatches, sonst Buttons)
    var optionNames = (product.options || []).map(function (o) { return o.name || o; });
    var state = {}; // optionName -> value

    function optionValues(pos) {
      var seen = {};
      var vals = [];
      variants.forEach(function (v) {
        var val = v['option' + (pos + 1)];
        if (val != null && !seen[val]) { seen[val] = 1; vals.push(val); }
      });
      return vals;
    }

    function resolve() {
      return variants.find(function (v) {
        return optionNames.every(function (name, pos) {
          return state[name] == null || v['option' + (pos + 1)] === state[name];
        }) && optionNames.every(function (name) { return state[name] != null; });
      });
    }

    // Ist für diesen Options-Wert (unter Berücksichtigung bereits gewählter
    // ANDERER Optionen) irgendeine Variante verfügbar? Wenn keine ANDERE Option
    // gewählt ist, prüft das über ALLE Varianten dieser Farbe → durchgestrichen
    // wird nur, wenn die Farbe komplett ausverkauft ist.
    function isValueAvailable(pos, val) {
      return variants.some(function (v) {
        if (v['option' + (pos + 1)] !== val) return false;
        for (var p = 0; p < optionNames.length; p++) {
          if (p === pos) continue;
          var sel = state[optionNames[p]];
          if (sel != null && v['option' + (p + 1)] !== sel) return false;
        }
        return v.available;
      });
    }

    // Kleines Produktbild an die aktuelle (Teil-)Auswahl anpassen – bevorzugt
    // die gewählte Farbe, damit der Kunde den Farbunterschied sofort sieht.
    function updateThumb() {
      var partial = variants.filter(function (v) {
        return optionNames.every(function (n, p) { return state[n] == null || v['option' + (p + 1)] === state[n]; });
      });
      var rep = partial.filter(function (v) { return v.available; })[0] || partial[0];
      if (!rep) return;
      var src = pickVariantImage(rep, pickProductImage(product));
      var thumb = self.root.querySelector('[data-sparset-slot="' + idx + '"] [data-slot-thumb]');
      if (thumb && src) thumb.src = imgUrl(src, 160);
    }

    // Einen Options-Wert wählen (gemeinsamer Pfad für Swatch-Klick UND
    // Auswahl aus dem Farb-Overlay): Konflikte freigeben, neu rendern,
    // Bild + Variante + Prefill aktualisieren.
    function selectValue(pos, val) {
      state[optionNames[pos]] = val;
      var cleared = true;
      while (cleared) {
        cleared = false;
        optionNames.forEach(function (n, p) {
          if (p === pos || state[n] == null) return;
          if (!isValueAvailable(p, state[n])) { state[n] = null; cleared = true; }
        });
      }
      render();
      updateThumb();
      var variant = resolve();
      var status = wrap.querySelector('[data-slot-status]');
      if (variant && variant.available) {
        self.commitVariant(idx, product, variant);
        if (status) status.textContent = '';
      } else {
        self.selection[idx] = null;
        if (status) status.textContent = variant ? 'Diese Kombination ist ausverkauft.' : 'Bitte alle Optionen wählen.';
      }
      if (isColorOption(optionNames[pos])) {
        self.userPickedColor[idx] = true;
        // Nur der ERSTE Farb-Klick im Set füllt die anderen Slots vor.
        if (!self.prefillDone) {
          self.prefillDone = true;
          // Auch den EIGENEN Slot vervollständigen (Typ/Größe/… vorwählen),
          // damit nach dem ersten Klick überall eine komplette Auswahl steht.
          if (optionNames.some(function (n) { return state[n] == null; })) {
            applyColor(state[optionNames[pos]]);
          }
          self.propagateColor(idx, state[optionNames[pos]]);
        }
        // Die Galerie folgt IMMER der Farbe des ERSTEN Produkts (Slot 0):
        // jeder Farbwechsel dort blendet oben das passende Set-Bild ein.
        if (idx === 0) self.showGalleryImageForColor(state[optionNames[pos]]);
      }
      self.renderSummary();
    }

    // Farb-Übersicht als Overlay: jede verfügbare Farbe mit echtem Produktfoto
    // + Name; Tippen wählt die Farbe und schließt. Bildquelle sind die
    // Variantenbilder (kein extra Asset, immer aktuell).
    function openColorGrid(colorPos, name) {
      // Foto pro Farbe passend zu den AKTUELL gewählten anderen Optionen
      // (z. B. Sterne statt Wimpel, Mit Gold statt Ohne): Variante mit den
      // meisten Übereinstimmungen gewinnt, Verfügbarkeit bricht Gleichstand.
      function tileVariantFor(val) {
        var best = null, bestScore = -1;
        variants.forEach(function (v) {
          if (v['option' + (colorPos + 1)] !== val) return;
          var score = v.available ? 1 : 0;
          optionNames.forEach(function (n, p) {
            if (p === colorPos || state[n] == null) return;
            if (v['option' + (p + 1)] === state[n]) score += 2;
          });
          if (score > bestScore) { bestScore = score; best = v; }
        });
        return best;
      }
      var tiles = optionValues(colorPos).map(function (val) {
        var pick = tileVariantFor(val);
        var img = pick ? pickVariantImage(pick, pickProductImage(product)) : pickProductImage(product);
        var active = state[name] === val ? ' is-active' : '';
        return '<button type="button" class="sparset-colorgrid__tile' + active + '" data-cg-val="' + esc(val) + '">' +
          '<img src="' + esc(imgUrl(img, 360)) + '" alt="" loading="lazy">' +
          '<span>' + esc(val) + '</span></button>';
      }).join('');
      // Gewählte andere Optionen im Titel zeigen ("Sterne, Mit Goldapplikation")
      var picked = [];
      optionNames.forEach(function (n, p) {
        if (p !== colorPos && state[n] != null) picked.push(state[n]);
      });
      var sub = picked.length ? '<small class="sparset-colorgrid__sub">' + esc(picked.join(' · ')) + '</small>' : '';
      var overlay = document.createElement('div');
      overlay.className = 'sparset-colorgrid';
      overlay.innerHTML =
        '<div class="sparset-colorgrid__panel" role="dialog" aria-modal="true">' +
          '<div class="sparset-colorgrid__head">' +
            '<span><strong>' + esc(product.title) + ' – Farbe wählen</strong>' + sub + '</span>' +
            '<button type="button" class="sparset-colorgrid__close" aria-label="Schließen">&times;</button>' +
          '</div>' +
          '<div class="sparset-colorgrid__grid">' + tiles + '</div>' +
        '</div>';
      document.body.appendChild(overlay);
      var prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      function close() {
        overlay.remove();
        document.documentElement.style.overflow = prevOverflow;
        document.removeEventListener('keydown', onKey);
      }
      function onKey(e) { if (e.key === 'Escape') close(); }
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.closest('.sparset-colorgrid__close')) { close(); return; }
        var tile = e.target.closest('[data-cg-val]');
        if (tile) { selectValue(colorPos, tile.getAttribute('data-cg-val')); close(); }
      });
      document.addEventListener('keydown', onKey);
    }

    // Mobil: eingeklappte Farb-Reihen (Bestsellerfarben zuerst); merkt sich
    // pro Option, ob der Kunde "alle Farben" aufgeklappt hat.
    var expandedColors = {};
    // Einmal in der eingeklappten Reihe gezeigte Zusatz-Farben (z. B. durch
    // Vorauswahl) bleiben dauerhaft sichtbar – die Reihe schrumpft nie wieder.
    var stickyExtras = {};

    // Bestseller-Auswahl für eine Werte-Liste: pro topColor der erste Wert,
    // der exakt passt oder dessen Hauptton (erstes Token) passt.
    function topColorValues(vals) {
      var top = [];
      (self.cfg.topColors || []).forEach(function (tc) {
        var tcn = colorNorm(tc);
        var found = null;
        vals.forEach(function (v) {
          if (found || top.indexOf(v) !== -1) return;
          var vn = colorNorm(v);
          if (vn === tcn || colorTokens(v)[0] === tcn) found = v;
        });
        if (found) top.push(found);
      });
      return top;
    }

    function render() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var html = optionNames.map(function (name, pos) {
        var isColor = /(farbe|color|colour)/i.test(name);
        var vals = optionValues(pos);
        var hiddenCount = 0, showCollapse = false;
        if (isColor && isMobile && (self.cfg.topColors || []).length && !expandedColors[name]) {
          var top = topColorValues(vals);
          // Früher gezeigte Zusatz-Farben beibehalten (Reihe schrumpft nie)
          (stickyExtras[name] || []).forEach(function (v) {
            if (vals.indexOf(v) !== -1 && top.indexOf(v) === -1) top.push(v);
          });
          // Aktive (z. B. vorausgewählte) Farbe immer mit anzeigen + merken
          if (state[name] != null && top.indexOf(state[name]) === -1) {
            top.push(state[name]);
            if (!stickyExtras[name]) stickyExtras[name] = [];
            if (stickyExtras[name].indexOf(state[name]) === -1) stickyExtras[name].push(state[name]);
          }
          // Nur einklappen, wenn dadurch wirklich Platz gespart wird
          if (top.length && vals.length - top.length >= 2) {
            hiddenCount = vals.length - top.length;
            vals = top; // eingeklappt: Bestseller + gemerkte Zusatz-Farben
          }
        } else if (isColor && (self.cfg.topColors || []).length) {
          // Aufgeklappt/Desktop: Bestseller zuerst, Rest in Originalreihenfolge
          var topAll = topColorValues(vals);
          vals = topAll.concat(vals.filter(function (v) { return topAll.indexOf(v) === -1; }));
          // Mobil aufgeklappt: "Weniger anzeigen" anbieten
          if (isMobile && expandedColors[name]) showCollapse = true;
        }
        var items = vals.map(function (val) {
          var soldOut = !isValueAvailable(pos, val);
          var active = state[name] === val ? ' is-active' : '';
          if (isColor) {
            return '<button type="button" class="sparset-swatch' + active + (soldOut ? ' is-soldout' : '') +
              '" data-opt="' + pos + '" data-val="' + esc(val) + '" aria-label="' + esc(val) + '">' +
              '<span class="sparset-swatch__dot" style="background:' + self.colorFromName(val) + '"></span></button>';
          }
          return '<button type="button" class="sparset-chip' + active + (soldOut ? ' is-soldout' : '') +
            '" data-opt="' + pos + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('');
        // Eingeklappt: "+N"-Kachel zum Aufklappen der restlichen Farben
        if (hiddenCount > 0) {
          items += '<button type="button" class="sparset-swatch-more" data-cg-expand="' + esc(name) + '"' +
            ' aria-label="' + hiddenCount + ' weitere Farben anzeigen">+' + hiddenCount + '</button>';
        }
        // Aufgeklappt (mobil): "−"-Kachel zum wieder Einklappen
        if (showCollapse) {
          items += '<button type="button" class="sparset-swatch-more" data-cg-collapse="' + esc(name) + '"' +
            ' aria-label="Weniger Farben anzeigen">&minus;</button>';
        }
        // Bei Farb-Optionen: dezenter Link zur Farb-Übersicht (echte Fotos).
        var colorGrid = isColor
          ? '<button type="button" class="sparset-colorgrid-open" data-cg-open="' + pos + '">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
              '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/>' +
              '<rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>' +
              'Alle Farben ansehen</button>'
          : '';
        return '<div class="sparset-slot__field">' +
          '<span class="sparset-slot__field-label">' + esc(name) + '</span>' +
          '<div class="sparset-opts' + (isColor ? ' sparset-opts--swatch' : '') + '">' + items + '</div>' +
          colorGrid +
        '</div>';
      }).join('');
      wrap.innerHTML = html + '<p class="sparset-slot__status" data-slot-status></p>';

      wrap.querySelectorAll('[data-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectValue(parseInt(btn.getAttribute('data-opt'), 10), btn.getAttribute('data-val'));
        });
      });
      wrap.querySelectorAll('[data-cg-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = parseInt(btn.getAttribute('data-cg-open'), 10);
          openColorGrid(pos, optionNames[pos]);
        });
      });
      wrap.querySelectorAll('[data-cg-expand]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          expandedColors[btn.getAttribute('data-cg-expand')] = true;
          render();
        });
      });
      wrap.querySelectorAll('[data-cg-collapse]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          expandedColors[btn.getAttribute('data-cg-collapse')] = false;
          render();
        });
      });
    }

    // Passende Farbe von außen setzen (Vorschlag, bleibt änderbar).
    // Bereits manuell gewählte Nicht-Farb-Optionen (Größe, Typ, …) bleiben
    // erhalten, sofern es die Kombination verfügbar gibt.
    function applyColor(sourceVal) {
      var colorPos = -1;
      optionNames.forEach(function (n, p) {
        if (colorPos === -1 && isColorOption(n)) colorPos = p;
      });
      if (colorPos === -1) return false;

      var availVals = optionValues(colorPos).filter(function (val) {
        return variants.some(function (v) {
          return v['option' + (colorPos + 1)] === val && v.available;
        });
      });
      var best = self.bestColorMatch(sourceVal, availVals);
      var cands;
      if (best) {
        cands = variants.filter(function (v) {
          return v['option' + (colorPos + 1)] === best && v.available;
        });
      } else {
        // Gewählte Farbe gibt es hier gar nicht (mehr): trotzdem etwas
        // Verfügbares vorwählen (z. B. andere Farbe/Typ), damit der Kunde
        // keine leeren Slots und Fehlermeldungen bekommt – bleibt änderbar.
        cands = variants.filter(function (v) { return v.available; });
      }
      // Bereits gesetzte andere Optionen möglichst beibehalten
      var kept = cands.filter(function (v) {
        return optionNames.every(function (n, p) {
          if (p === colorPos || state[n] == null) return true;
          return v['option' + (p + 1)] === state[n];
        });
      });
      if (kept.length) cands = kept;
      if (!cands.length) return false;

      var slotLabel = ((self.slots[idx] && self.slots[idx].label) || '').toLowerCase();
      var cand = cands[0], candScore = -1;
      cands.forEach(function (v) {
        var score = 0;
        optionNames.forEach(function (n, p) {
          if (p === colorPos) return;
          var val = String(v['option' + (p + 1)] || '').toLowerCase().trim();
          if (val && slotLabel.indexOf(val) !== -1) score += 5;
          // Explizite Vorgabe aus der Config (z. B. "Ohne Himmelstange")
          if (prefer && prefer[n] != null && colorNorm(v['option' + (p + 1)]) === colorNorm(prefer[n])) score += 8;
        });
        if (score > candScore) { candScore = score; cand = v; }
      });

      optionNames.forEach(function (n, p) { state[n] = cand['option' + (p + 1)]; });
      render();
      updateThumb();
      self.commitVariant(idx, product, cand);
      // Bekommt das ERSTE Produkt seine Farbe per Vorauswahl, zieht die
      // Galerie ebenfalls mit (sie spiegelt immer die Slot-1-Farbe).
      if (idx === 0 && colorPos !== -1) self.showGalleryImageForColor(cand['option' + (colorPos + 1)]);
      return true;
    }

    self.pickers[idx] = {
      applyColor: applyColor,
      // Für die Warenkorb-Meldungen: welche Optionen sind noch nicht gewählt?
      missingOptions: function () {
        return optionNames.filter(function (n) { return state[n] == null; });
      },
    };
    render();
    // Slot lädt evtl. nach der ersten Farbwahl des Kunden → Vorschlag nachziehen
    if (self.lastColor && !self.userPickedColor[idx]) {
      applyColor(self.lastColor);
      self.renderSummary();
    }
  };

  /* ---------- Farb-Vorauswahl über Slots hinweg ---------- */

  function isColorOption(name) {
    return /(farbe|color|colour)/i.test(String(name || ''));
  }

  function colorNorm(s) { return String(s || '').toLowerCase().replace(/ß/g, 'ss').trim(); }

  function colorTokens(s) {
    return colorNorm(s).split(/\s*[&\/,+]\s*|\s+und\s+/)
      .map(function (t) { return t.trim(); })
      .filter(Boolean);
  }

  // Vom Kunden gewählte Farbe als Vorschlag in alle anderen Slots übernehmen.
  Sparset.prototype.propagateColor = function (fromIdx, colorVal) {
    if (!colorVal) return;
    this.lastColor = colorVal;
    var self = this;
    this.pickers.forEach(function (picker, i) {
      if (i === fromIdx || !picker || self.userPickedColor[i]) return;
      picker.applyColor(colorVal);
    });
  };

  // Beste Übereinstimmung für einen Farbnamen finden; unterstützt
  // zusammengesetzte Werte ("Altrosa & Hellbeige") über Token-Vergleich.
  Sparset.prototype.bestColorMatch = function (source, candidates) {
    var st = colorTokens(source);
    if (!st.length) return null;
    var best = null, bestScore = 0;
    (candidates || []).forEach(function (c) {
      var score = 0;
      if (colorNorm(c) === colorNorm(source)) {
        score = 100;
      } else {
        var ct = colorTokens(c);
        var inter = ct.filter(function (t) { return st.indexOf(t) !== -1; }).length;
        if (inter) {
          score = 40 + inter * 10;
          if (ct[0] === st[0]) score += 15; // gleiche Hauptfarbe an erster Stelle
        }
      }
      if (score > bestScore) { bestScore = score; best = c; }
    });
    return best;
  };

  Sparset.prototype.commitVariant = function (idx, product, variant) {
    if (!variant) { this.selection[idx] = null; return; }
    var priceCents = typeof variant.price === 'number'
      ? variant.price
      : Math.round(parseFloat(variant.price) * 100);
    this.selection[idx] = {
      productId: product.id,
      handle: product.handle,
      title: product.title,
      variantId: variant.id,
      variantTitle: variant.title,
      price: priceCents,
      image: pickVariantImage(variant, pickProductImage(product)),
    };
  };

  /* ---------- Preis / Summary ---------- */

  Sparset.prototype.subtotalCents = function () {
    return this.selection.reduce(function (s, it) { return s + (it ? it.price : 0); }, 0);
  };

  // Liefert { total, saving } in Cents nach Pricing-Modus.
  Sparset.prototype.priced = function () {
    var sub = this.subtotalCents();
    var mode = this.pricing.mode;
    var val = parseFloat(this.pricing.value);
    if (!isFinite(val)) return { total: sub, saving: 0 };
    if (mode === 'fixed') {
      var target = Math.round(val); // Cents
      target = Math.min(target, sub);
      return { total: target, saving: Math.max(0, sub - target) };
    }
    if (mode === 'percent') {
      var pct = Math.max(0, Math.min(50, val));
      var saving = Math.round(sub * pct / 100);
      return { total: sub - saving, saving: saving };
    }
    return { total: sub, saving: 0 };
  };

  // Konkrete Hinweise, was pro Pflicht-Komponente noch fehlt (für CTA-Klick).
  Sparset.prototype.missingMessages = function () {
    var msgs = [];
    for (var i = 0; i < this.slots.length; i++) {
      var slot = this.slots[i] || {};
      if (slot.required === false || this.selection[i]) continue;
      var label = slot.label || ('Komponente ' + (i + 1));
      if (!this.chosenProduct[i]) { msgs.push(label + ': bitte Produkt wählen'); continue; }
      var picker = this.pickers[i];
      if (picker) {
        var miss = picker.missingOptions();
        var missTxt = miss.length <= 1 ? miss.join('')
          : miss.slice(0, -1).join(', ') + ' und ' + miss[miss.length - 1];
        if (miss.length) msgs.push(label + ': bitte ' + missTxt + ' wählen');
        else msgs.push(label + ': gewählte Kombination ist ausverkauft – bitte anders wählen');
      } else {
        msgs.push(label + ': bitte Optionen wählen');
      }
    }
    return msgs;
  };

  Sparset.prototype.requiredMissing = function () {
    var missing = 0;
    for (var i = 0; i < this.slots.length; i++) {
      var required = this.slots[i].required !== false;
      if (required && !this.selection[i]) missing++;
    }
    return missing;
  };

  Sparset.prototype.renderSummary = function () {
    if (this.elList) {
      var rows = '';
      for (var i = 0; i < this.slots.length; i++) {
        var sel = this.selection[i];
        var label = (this.slots[i] && this.slots[i].label) || ('Komponente ' + (i + 1));
        if (sel) {
          rows +=
            '<li class="sparset-summary__item">' +
              '<img src="' + esc(imgUrl(sel.image, 80)) + '" alt="" width="40" height="40" loading="lazy">' +
              '<span class="sparset-summary__item-txt"><strong>' + esc(sel.title) + '</strong>' +
                (sel.variantTitle && !/^(default title|standard)$/i.test(sel.variantTitle) ? '<br><small>' + esc(sel.variantTitle) + '</small>' : '') +
              '</span>' +
              '<span class="sparset-summary__item-price">' + formatMoney(sel.price) + '</span>' +
            '</li>';
        } else {
          rows += '<li class="sparset-summary__item sparset-summary__item--empty"><span>' + esc(label) + '</span><span>–</span></li>';
        }
      }
      if (this.gift) {
        rows +=
          '<li class="sparset-summary__item sparset-summary__item--gift">' +
            '<img src="' + esc(imgUrl(this.gift.image, 80)) + '" alt="" width="40" height="40" loading="lazy">' +
            '<span class="sparset-summary__item-txt"><strong>' + esc(this.gift.label) + '</strong><br><small>Geschenk zu deinem Set</small></span>' +
            '<span class="sparset-summary__item-price"><s>' + formatMoney(this.gift.price * this.gift.qty) + '</s> <strong>GRATIS</strong></span>' +
          '</li>';
      }
      this.elList.innerHTML = rows;
    }

    var p = this.priced();
    var components = this.subtotalCents();
    var giftVal = this.gift ? this.gift.price * this.gift.qty : 0;
    // Zeige Ersparnis erst, sobald etwas gewählt ist (leerer Zustand = keine Zahlen).
    var showSaving = components > 0;
    var giftCounts = showSaving && giftVal > 0;
    // "Einzeln gekauft" = Komponenten + Wert des Geschenks; so bleibt
    // Einzeln − Vorteil − Geschenk = Sparset-Preis konsistent.
    var displaySubtotal = components + (giftCounts ? giftVal : 0);
    var totalSaving = p.saving + (giftCounts ? giftVal : 0);

    if (this.elSubtotal) this.elSubtotal.innerHTML = formatMoney(displaySubtotal);
    if (this.elTotal) this.elTotal.innerHTML = formatMoney(p.total);
    if (this.elSavingRow) {
      if (showSaving && p.saving > 0) {
        this.elSavingRow.hidden = false;
        if (this.elSaving) this.elSaving.innerHTML = '−' + formatMoney(p.saving);
      } else {
        this.elSavingRow.hidden = true;
      }
    }
    if (this.elGiftRow) {
      if (giftCounts) {
        this.elGiftRow.hidden = false;
        if (this.elGiftLabel) this.elGiftLabel.textContent = this.gift.label + ' geschenkt';
        if (this.elGiftSaving) this.elGiftSaving.innerHTML = '−' + formatMoney(giftVal);
      } else {
        this.elGiftRow.hidden = true;
      }
    }
    if (this.elTotalSavingRow) {
      if (showSaving && totalSaving > 0) {
        this.elTotalSavingRow.hidden = false;
        if (this.elTotalSaving) this.elTotalSaving.innerHTML = formatMoney(totalSaving);
      } else {
        this.elTotalSavingRow.hidden = true;
      }
    }

    var missing = this.requiredMissing();
    if (this.elHint) {
      this.elHint.textContent = missing > 0
        ? (missing === 1 ? 'Noch 1 Pflicht-Komponente wählen.' : 'Noch ' + missing + ' Pflicht-Komponenten wählen.')
        : '';
    }
    // CTA bleibt klickbar – bei unvollständiger Auswahl zeigt der Klick
    // konkrete Hinweise (max. 3) statt stumm nichts zu tun.
    if (this.elCta) this.elCta.disabled = false;
    if (this.elError && this.showMissing) {
      if (missing > 0) {
        var msgs = this.missingMessages().slice(0, 3);
        this.elError.innerHTML = msgs.map(esc).join('<br>');
        this.elError.classList.add('is-visible');
      } else {
        this.showMissing = false;
        this.elError.innerHTML = '';
        this.elError.classList.remove('is-visible');
      }
    }
  };

  /* ---------- Add to Cart ---------- */

  Sparset.prototype.addToCart = function () {
    var self = this;
    if (this.requiredMissing() > 0) {
      // Konkrete Hinweise zeigen + zur ersten offenen Komponente scrollen.
      this.showMissing = true;
      this.renderSummary();
      for (var s = 0; s < this.slots.length; s++) {
        if (this.slots[s].required !== false && !this.selection[s]) {
          var slotEl = this.root.querySelector('[data-sparset-slot="' + s + '"]');
          if (slotEl && slotEl.scrollIntoView) slotEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          break;
        }
      }
      return;
    }
    this.showMissing = false;
    if (this.elError) { this.elError.innerHTML = ''; this.elError.classList.remove('is-visible'); }

    // Eindeutig je Add, auch ueber Seitenaufrufe hinweg. Der Zaehler allein reichte
    // nicht: er steht auf Modulebene, faengt nach jedem Seitenaufruf wieder bei 1 an,
    // und nach jedem Add springt die Seite auf /cart. Zwei Kaeufe desselben Sparsets
    // landeten deshalb in DERSELBEN Bundle-Gruppe - mit zwei Folgen (Auftrag #17520,
    // 15.09.2026): das Gratis-Geschenk ging doppelt raus, und die Discount-Function
    // nimmt per firstAttr den _bundle_pct der ERSTEN Line fuer die ganze Gruppe
    // (dort lagen 15 % und 20 % nebeneinander).
    //
    // Format: Der Zufallsteil bleibt frei von Bindestrichen - die Function erkennt
    // Sparsets am Praefix "SP-" und liest die Soll-Stueckzahl per /-n(\d+)$/ vom Ende.
    bundleCounter += 1;
    var bundleId = 'SP-' + (this.cfg.productId || 'x') + '-' +
      Date.now().toString(36) + bundleCounter.toString(36) +
      Math.random().toString(36).slice(2, 10);

    var props = { _bundle_id: bundleId };
    if (this.pricing.mode === 'percent') {
      props._bundle_pct = String(Math.max(0, Math.min(50, parseFloat(this.pricing.value) || 0)));
    } else if (this.pricing.mode === 'fixed') {
      props._bundle_total = String(Math.round(parseFloat(this.pricing.value) || 0));
    }
    if (!this.hideProperty) props[this.bundleLabel] = 'Ja';

    var items = [];
    for (var i = 0; i < this.selection.length; i++) {
      var sel = this.selection[i];
      if (!sel) continue; // optionale, ungewählte Slots überspringen
      items.push({ id: sel.variantId, quantity: 1, properties: props });
    }
    if (!items.length) return;

    // Soll-Stueckzahl des Sets mitgeben. Die Discount-Function gewaehrt den
    // Sparset-Rabatt nur, solange die Gruppe noch mindestens so viele Einheiten
    // hat — sonst bekaeme man nach dem Loeschen einzelner Positionen die 20 %
    // weiter auf den Rest (Befund Lukas 2026-08-17). Alle Items teilen sich
    // dieselbe props-Referenz, die Felder greifen daher fuer alle.
    //
    // Die Zahl steht doppelt drin: einmal als eigene Property und einmal als
    // Suffix "-n<Anzahl>" in der _bundle_id. Grund: ein NEU in die Function-
    // Input-Query aufgenommenes attribute-Feld kam im Live-Checkout nicht an
    // (Deploy 17.08. — WASM sofort aktiv, neues Query-Feld nicht), waehrend
    // _bundle_id als laengst etabliertes Feld zuverlaessig ankommt.
    props._bundle_n = String(items.length);
    props._bundle_id = bundleId + '-n' + items.length;

    // Geschenk-Line: gleiche Bundle-Gruppe + _bundle_gift, Function setzt sie auf 0 €.
    if (this.gift) {
      var giftProps = {};
      for (var gk in props) giftProps[gk] = props[gk];
      giftProps._bundle_gift = '1';
      if (!this.hideProperty) giftProps['Geschenk'] = this.gift.label;
      items.push({ id: this.gift.variantId, quantity: this.gift.qty, properties: giftProps });
    }

    this.elCta.disabled = true;
    var original = this.elCta.textContent;
    this.elCta.textContent = 'Wird hinzugefügt…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || ('HTTP ' + res.status)); });
        window.location.href = '/cart';
      })
      .catch(function (err) {
        if (self.elError) {
          self.elError.textContent = 'Fehler: ' + err.message;
          self.elError.classList.add('is-visible');
        }
        self.elCta.disabled = false;
        self.elCta.textContent = original;
      });
  };

  /* ---------- Farb-Swatch aus Namen ---------- */

  // Ersatzpalette für Einzeltöne, die (noch) nicht in settings.color_swatches
  // stehen – Werte identisch mit der Theme-Farbtabelle gehalten.
  var COLOR_FALLBACK = {
    'altrosa': '#DC9A96', 'puderrosa': '#DBB4B6', 'beigerosa': '#E0C4B6', 'sanftrosa': '#E0C4B6',
    'rosa': '#E8C4C3', 'blau': '#6E7B8F', 'eukalyptus': '#93A396', 'grün': '#93A396', 'gruen': '#93A396',
    'senfgelb': '#DBAE5D', 'gelb': '#DBAE5D', 'flieder': '#978CA7', 'lila': '#978CA7',
    'hellbeige': '#AF9E8C', 'dunkelbeige': '#896857', 'beige': '#C3B6A7', 'creme': '#D7BEA2',
    'nougat': '#B47B5C', 'braun': '#B47B5C', 'grau': '#9aa0a6',
    'weiß': '#FFFFFF', 'weiss': '#FFFFFF', 'gold': '#caa75e', 'schwarz': '#222222',
  };

  // Hex-Liste -> Swatch-Hintergrund im Stil der nativen Theme-Swatches
  // (2 Farben: diagonale Halbkreise, 3 Farben: Drittel-Kreis via conic).
  function swatchBackground(hexes) {
    if (!hexes.length) return 'rgba(0,0,0,0.15)';
    if (hexes.length === 1) return hexes[0];
    if (hexes.length === 2) {
      return 'linear-gradient(135deg, ' + hexes[0] + ' 0%, ' + hexes[0] + ' 49.9%, ' + hexes[1] + ' 50%, ' + hexes[1] + ' 100%)';
    }
    var step = 360 / hexes.length;
    var stops = hexes.map(function (h, i) {
      return h + ' ' + Math.round(i * step) + 'deg ' + Math.round((i + 1) * step) + 'deg';
    });
    return 'conic-gradient(' + stops.join(', ') + ')';
  }

  Sparset.prototype.colorFromName = function (name) {
    var raw = String(name || '').toLowerCase().trim();
    if (!raw) return 'rgba(0,0,0,0.15)';
    var self = this;
    var tokens = raw.split(/\s*[&\/+]\s*|\s+und\s+/).map(function (t) { return t.trim(); }).filter(Boolean);

    // Einzeltöne des Namens auflösen ("Hellbeige & Creme & Dunkelbeige").
    var tokenHexes = [];
    tokens.forEach(function (t) {
      var h = self.swatchMap[t] || COLOR_FALLBACK[t];
      if (!h) { // Teil-Treffer ("senfgelb" in "senfgelb (limitiert)")
        for (var k in COLOR_FALLBACK) { if (t.indexOf(k) !== -1) { h = COLOR_FALLBACK[k]; break; } }
      }
      if (h) tokenHexes.push(String(h).split(',')[0].trim());
    });

    // 1) Exakter Treffer in der Theme-Farbtabelle (inkl. Kombi-Einträgen
    //    "Flieder & Creme:#…,#…") – identisch zu den nativen PDP-Swatches.
    //    ABER: Pflegt die Tabelle weniger Farben als der Name Töne hat
    //    (z. B. Dreifach-Kombi mit nur 2 Hexwerten), gewinnen die Einzeltöne.
    var hit = this.swatchMap[raw];
    if (hit) {
      var hitHexes = String(hit).split(',').map(function (h) { return h.trim(); });
      if (tokenHexes.length > hitHexes.length) return swatchBackground(tokenHexes);
      return swatchBackground(hitHexes);
    }

    // 2) Kombi aus Einzeltönen zusammensetzen.
    if (tokenHexes.length) return swatchBackground(tokenHexes);

    // 3) "Bunt" & Unbekanntes: neutrale Mehrfarb-Kachel statt grauem Fleck.
    if (raw.indexOf('bunt') !== -1) {
      return swatchBackground(['#DC9A96', '#DBAE5D', '#93A396', '#6E7B8F']);
    }
    return 'rgba(0,0,0,0.15)';
  };

  function init() {
    document.querySelectorAll('[data-sparset]').forEach(function (el) {
      if (el.dataset.sparsetInit) return;
      el.dataset.sparsetInit = '1';
      new Sparset(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
